export default function objectOmitNull<T>(obj: T | any) {
  for (var propName in obj) {
    if (obj[propName] == null) {
      delete obj[propName];
    }
  }
  return obj;
}
